
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { INASATVSchedule, INASATVScheduleEvent, IStaticDataLoadingStatus } from "../store-services/staticdata.types";

interface IScheduleEvent {
  time: string,
  content: string,
  channel: string
}
interface IScheduleDay {
  day: Date,
  today: boolean,
  dayStr: string,
  events: Array<IScheduleEvent>
}

@Component({
  filters: {
    time_str(value: string) {
      let d_fmt = new Intl.DateTimeFormat("en-US", {dateStyle: "medium", timeStyle: "short", })
      let d = new Date(value)
      return `${d_fmt.format(d)}`
    } 
  }
})
export default class NASATVScheduleComponent extends Vue {
  @Prop()
  value!: boolean;
  
  get show(): boolean {
    return this.value
  }
  set show(value: boolean) {
    this.$emit('input', value)
  }

  get schedule(): INASATVSchedule {
    return this.$store.getters["staticdata/getNASATVSchedule"];
  }
  get scheduleStatus(): IStaticDataLoadingStatus {
    return this.schedule.status;
  }
  get scheduleData(): Array<INASATVScheduleEvent> {
    return this.schedule.content?.data?.schedule || [] ;
  }

  get schedule_timeline(): Array<IScheduleDay> {
    let out = new Array<IScheduleDay>()
    
    let weekday_fmt = new Intl.DateTimeFormat("en-US", {weekday: "long", day: "numeric", month: "long"})
    let time_fmt = new Intl.DateTimeFormat("en-US", {timeStyle: "short"})
    let day_fmt = new Intl.DateTimeFormat("en-US", {day: "numeric", month: "long"})
    let tstext_fmt = (date: Date) => `${time_fmt.format(date)} on ${day_fmt.format(date)}`

    let day: IScheduleDay = {
      day: new Date(0),
      today: false,
      dayStr: "",
      events: []
    }
    for (let event of this.scheduleData) {
      let d = new Date(event.time)
      let outEvent: IScheduleEvent = {
        time: time_fmt.format(d),
        content: 
          event.content.replaceAll(/\[([^\]]*)\]\(([^\)]*)\)/g, (match, text, href) => `<a href="${href}" target="_blank">${text}</a>`)
          .replaceAll(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/g, (match) => day_fmt.format(d) == day_fmt.format(new Date(match)) ? time_fmt.format(new Date(match)) : tstext_fmt(new Date(match))),
        channel: event.channel
      }
      if (day.dayStr !== weekday_fmt.format(d)) {
        if (day.dayStr !== "") out.push(day)
        d.setHours(0, 0, 0, 0)
        day = {
          day: d,
          today: false,
          dayStr: weekday_fmt.format(d),
          events: []
        }
      }
      day.events.push(outEvent)
    }
    if (day.dayStr !== "") out.push(day)

    let today = new Date()
    today.setHours(0, 0, 0, 0)
    let todayIdx = out.findIndex((d) => d.day.getTime() === today.getTime())
    if (todayIdx >= 0) {
      out[todayIdx].today = true
    } else {
      out.push({
        day: today,
        today: true,
        dayStr: weekday_fmt.format(today),
        events: []
      })
    }

    out.sort((a, b) => a.day.getTime() - b.day.getTime())
    
    return out
  }

  close() {
    this.show = false;
  }

  updateSchedule() {
    this.$store.dispatch("staticdata/updateNASATVSchedule")
  }

  @Watch("value")
  watchValue(value: boolean) {
    // If re-opened within 5min won't re-request...
    if (value) {
      this.updateSchedule()
    }
  }
}
